import { FC } from "react";
import { Stack } from "@mui/material";
import { GridApi } from "ag-grid-community";
import moment from "moment/moment";
import { OpportunitiesCreateTaskToolbarAction } from "../../../common/opportunities/components/toolbar/OpportunitiesCreateTaskToolbarAction";
import { AGGridColumnsToolPanel } from "../../../common/ag-grid/components/AGGridColumnsToolPanel";
import { AgGridAllFiltersChip } from "../../../common/ag-grid/components/filters/AgGridAllFiltersChip";
import { AGGridExportCSV } from "@/components/pages/common/ag-grid/components/AGGridExportCSV";
import { formatDate } from "@/utils/helpers/date-time/datetime-format";
import { AgGridGlobalSearch } from "@/components/pages/common/ag-grid/components/global-search/AgGridGlobalSearch";
import { OpportunitiesCount } from "@/components/pages/common/opportunities/components/toolbar/OpportunitiesCount";
import { useAppSelector } from "@/store/hooks";
import { savingsOpportunitiesSelectedItemsSelector } from "@/store/savings-opportunities/selectors/selection/savingsOpportunitiesSelectedItemsSelector";

interface SavingsOpportunitiesTableToolbarProps {
  gridApi: GridApi | null;
}

export const SavingsOpportunitiesTableToolbar: FC<
  SavingsOpportunitiesTableToolbarProps
> = ({ gridApi }) => {
  const fileName = `${formatDate(moment(), { type: "dashSeparated" })}-Savings-Opportunities.csv`;

  const opportunities = useAppSelector(
    savingsOpportunitiesSelectedItemsSelector,
  );

  return (
    <Stack
      pr={2}
      pl={1}
      py={1}
      top={0}
      spacing={2}
      bgcolor="white"
      zIndex="appBar"
      position="sticky"
      direction="row"
      justifyContent="space-between"
      borderBottom={1}
      borderColor="grey.300"
    >
      <Stack direction="row" spacing={1} height={32} alignItems="center">
        <OpportunitiesCount gridApi={gridApi} />

        <AgGridAllFiltersChip gridApi={gridApi} />
      </Stack>

      <Stack
        direction="row"
        justifyContent="end"
        alignItems="center"
        spacing={2}
      >
        <Stack
          direction="row"
          borderRadius={2}
          bgcolor="grey.100"
          spacing={0.5}
        >
          <OpportunitiesCreateTaskToolbarAction opportunities={opportunities} />
        </Stack>

        <AgGridGlobalSearch gridApi={gridApi} />

        <AGGridExportCSV gridApi={gridApi} fileName={fileName} />

        <AGGridColumnsToolPanel gridApi={gridApi} />
      </Stack>
    </Stack>
  );
};
